import {useEffect} from "react";

const useIntersectionObserver = (props) => {
  const {
    target,
    onIntersect,
    threshold = 1,
    rootMargin = "0px"
  } = props;

  useEffect(() => {
    const observer = new IntersectionObserver(onIntersect, {
      rootMargin,
      threshold
    });
    const {current} = target;
    observer.observe(current);
    return () => {
      observer.unobserve(current);
    };
    // eslint-disable-next-line
  }, []);
};
export default useIntersectionObserver;
